export default function iframeEmbeds(selector) {
  const $embeds = $(selector);

  $embeds.each((key, el) => {
    const $el = $(el);

    const $iframe = $el.find('iframe');
    if (!$iframe.length) {
      return;
    }

    const height = parseInt($iframe.attr('height'), 10);
    if (height > 0) {
      $iframe.height(height);
    }
  });
}
